import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../styles/views/components/AIChatbot/HumanMessage.module.scss';

const HumanMessage = ({ message, userInitials }) => (
  <div className={styles.container}>
    <div className={styles.textWrapper}>
      {message.split(/\n/).map(line => <p style={{ margin: '5px 0' }}>{line}</p>)}
    </div>
    <div className={styles.initials}>
      <span>{userInitials}</span>
    </div>
  </div>
);

HumanMessage.propTypes = {
  userInitials: PropTypes.string,
  message: PropTypes.string,
};

HumanMessage.defaultProps = {
  userInitials: '',
  message: '',
};

export default HumanMessage;
